<template>
	<div class="header">
		<img src="../assets/block.png" class="black" @click="black">
		<img src="../assets/weiit_logo.png" class="weiitLogo" >
	</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		methods:{
			black(){
				this.$router.push('/login')
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.header{
		height: 60px;
		background: #3257FE;
		padding:0px 27px;
		display: flex;
		align-items: center;
		.black{
			cursor: pointer;
			height: 30px;
			margin-right: 261px;
		}
		.weiitLogo{
			height: 30px;
		}
	}

</style>
